import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If react-snap has prerendered content (not just the loader), hydrate it.
// The loader has id="app-loader" — prerendered pages won't have it.
const hasPrerenderedContent = rootElement.hasChildNodes() && !rootElement.querySelector('#app-loader');

if (hasPrerenderedContent) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
